import { render, staticRenderFns } from "./miniSwiperCom.vue?vue&type=template&id=8733c52e&scoped=true"
import script from "./miniSwiperCom.vue?vue&type=script&lang=js"
export * from "./miniSwiperCom.vue?vue&type=script&lang=js"
import style0 from "./miniSwiperCom.vue?vue&type=style&index=0&id=8733c52e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8733c52e",
  null
  
)

export default component.exports